export const symmetricKey = (a, b) => (
  a < b ? `${a}:${b}` : `${b}:${a}`
);
